export function updateWishlistAndDispatchEvent(productId, variantId, productHandle) {
    try {
        // Validate inputs
        if (!productId || !variantId || !productHandle) {
            throw new Error("Invalid input: productId, variantId, and productHandle are required.");
        }

        // Check if the wishlist button exists
        const wishlistButton = document.getElementById("fusionPdpWhishlistTrigger");
        if (!wishlistButton) {
            throw new Error("Wishlist button is not available.");
        }

        // Update wishlist button data attributes
        wishlistButton.dataset.productId = productId;
        wishlistButton.dataset.variantId = variantId;
        wishlistButton.dataset.withEpi = "true";
        wishlistButton.dataset.swaction = "addToWishlist";
        wishlistButton.dataset.productUrl = `https://www.buffbunny.com/products/${productHandle}`;

        // Check if document and CustomEvent are available
        if (typeof document === 'undefined' || typeof CustomEvent === 'undefined') {
            throw new Error("Document or CustomEvent is not available in this environment.");
        }

        // Dispatch the swym:variant-change event with the correct detail object
        document.dispatchEvent(new CustomEvent("swym:variant-change", {
            detail: {
                variant: {
                    id: variantId,
                    productId: productId,
                    url: `https://www.buffbunny.com/products/${productHandle}`
                }
            }
        }));

    } catch (error) {
        console.error("An error occurred:", error.message);
    }
}

// Example usage:
// updateWishlistAndDispatchEvent('product123', 'variant456', 'example-product-handle');